const SlotPositionChoices = [
  { id: 'before', name: 'Before' },
  { id: 'after', name: 'After' },
  { id: 'prepend', name: 'Prepend' },
  { id: 'append', name: 'Append' }
];

export default SlotPositionChoices;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/StaticData/SlotPositionChoices.tsx